import React, { useState, useContext, useEffect } from "react";
import ConfigContext from "../context/ConfigContext";
import GC from "@grapecity/spread-sheets";
import { SpreadSheets } from "@grapecity/spread-sheets-react";
import { saveAs } from "file-saver";
import reportLoader from "../content/images/search_loading.gif";
import { Link } from "react-router-dom";
import ExcelRequestContract from "../contracts/ExcelRequestContract";
import { fetchReport, setBlobFromData, configureSheet, spreadActiveSheetChanged } from "../Utils/ReportUtils";
import "./spreadTheme.css";

// Import ExcelIO module
import * as ExcelIO from "@grapecity/spread-excelio";

// axios.get("api/Settings/GetJsSpreadLicense").then((result) => {
const spreadJsLicense = "devqaprod,348928238523931#B0LevJHbBdEVPJmbnJVdClkcFZ6UwkHS654Yr36Zw8Gai5UQr5mZplmQ5dFahFFcYdldChkS8sSSaxUZ8lGZudDZrd6aTREUnl6QRRTY74UZQJzRWlnblJ7KPplMQtmShNUMFBjU6NGRLFlRBNUWQx4LnFkR93yMKpWckRUMBZTczdVRvoWbw24Qrd7Yt3EaJZFZpxkbqpGT8IDWBlTYhlmavk5ZmtUMPtyNjhGRRRTTM5UUJdWZNdmRGNVUEd6byJGdvZ7RLV5cnlDRWtyU92mUU9mWxgGZYNHNsFzVzg7MRNmNqtES5U5KKNmdvgmTV9GdhRGV7RTZERneSJmbEdTVXB5LGV7SRJ6UoJUNIlURxd7aycjR8MFbQ3SVvVzdwonVBdHVsRnRyI7akZmI0IyUiwiI4QEN7MkR7UjI0ICSiwCNygTM9kTOyYTM0IicfJye#4Xfd5nIFVUSWJiOiMkIsICNx8idgAyUKBCZhVmcwNlI0IiTis7W0ICZyBlIsISOyMzM7ADIyAjMxEjMwIjI0ICdyNkIsISbvNmLsFWaj9WYulmZhJHdzV6auYXZkNHduVWblRXY4NnbvlGdhNnblBXbvNGLt36YuwWYpNmbh9WamFmc4NXZr9SYxNHduVWblRXY4NnbvlGdhNnblBXbvNGLt36YuwWYpNmbh9WamFmc4NXZr9yc49WZtVGdhR7cu3Wa4F6cuVGct36YiojIz5GRiwiIzdmbpRGbvhEIhJHdzV6SiojIh94QiwiIxMTOzITN8MjM8ITO8QzMiojIklkIs4XXbpjInxmZiwSZzxWYmpjIyNHZisnOiwmbBJye0ICRiwiI34zZoFFSq3ENpVjcygGVaVDUTlDdCZ7d0dnaHpkRxt6dvE7R5wmURJJRvV";
GC.Spread.Sheets.LicenseKey = spreadJsLicense;
ExcelIO.LicenseKey = spreadJsLicense;
// });

export const Report = ({ spread, setSpread, payPeriod, clientNumber }) => {
	const configData = useContext(ConfigContext);
	const hostStyle = { height: "100%", width: "100%" };
	const [pageTitle, setPageTitle] = useState("");
	const [exportBlob, setExportBlob] = useState(null);
	const [reportLoading, setReportLoading] = useState(true);
	const [hasError, setHasError] = useState(false);
	const [noData, setNoData] = useState(false);

	useEffect(() => {
		setTitle(payPeriod);
		generateReport();
	}, [payPeriod]);

	useEffect(() => {
		setReportLoading(true);
		setNoData(false);
		setHasError(false);
	}, [clientNumber, payPeriod]);

	const setTitle = (payPeriod) => {
		if (payPeriod != null) { setPageTitle(payPeriod.isPending === true ? "PENDING MASTER COMMISSION REPORT" : "STATEMENTS"); }
	};

	const generateReport = () => {
		if (clientNumber != null && payPeriod != null && spread) {
			const excelRequest = new ExcelRequestContract(clientNumber.toString(), payPeriod.payCycle, null, payPeriod.isPending);
			fetchReport(excelRequest, configData.REACT_APP_EXCEL_URL).then((result) => {
				if (result.status === 204) {
					setNoData(true);
					setReportLoading(false);
				} else {
					const blob = setBlobFromData(result.data);
					const excelIO = new ExcelIO.IO();
					excelIO.open(blob, (json) => {
						spread.fromJSON(json);
						const activeSheet = spread.getActiveSheet();
						configureSheet(activeSheet, spread);
						setExportBlob(blob);
						setReportLoading(false);
					}, (e) => {
						console.log("SpreadSheet error: ", e);
						setReportLoading(false);
						setHasError(true);
					});
				}
			}).catch(e => {
				console.log("Fetch report error: ", e.message);
				setReportLoading(false);
				setHasError(true);
			});
		}
	};

	const exportReport = () => {
		if (clientNumber != null && payPeriod != null && exportBlob != null) {
			const reportName = `${clientNumber.toString()}_${payPeriod.payCycle}.xlsx`;
			saveAs(exportBlob, reportName);
		}
	};

	const configureSheet = (activeSheet) => {
		activeSheet.options.isProtected = true;
		activeSheet.options.colHeaderVisible = false;
		activeSheet.options.rowHeaderVisible = false;
		if (spread != null) {
			spread.refresh();
		}
	};

	const spreadActiveSheetChanged = (type, sheetInfo) => {
		const sheet = sheetInfo.newSheet;
		configureSheet(sheet);
	};

	return (
		<div>
			<div className="col-lg-12 col-md-12 panel-heading">
				<h2 style={{ marginBottom: "0rem", color: "#fff" }}>{pageTitle}</h2>
			</div>

			<div className="box-layout" style={{ padding: "0% 2% 2% 2%" }}>
				<div className="row" style={{ padding: "0.3rem" }}>
					<div className="col-lg-12 col-md-12">
						{(!reportLoading && !hasError && !noData) && < button className='link' style={{ float: "right" }} onClick={exportReport}>Export to Excel</button>}
					</div>
				</div>
				<div className="row" style={{ padding: "0.3rem" }}>
					<div className="col-lg-12 col-md-12">
						{(!reportLoading && !hasError && !noData) && <Link to={`/home?clientNumber=${clientNumber.toString()}&payPeriod=${payPeriod.payCycle}&isPending=${payPeriod.isPending}`} target="_blank" className='link' style={{ float: "right" }}>Open in a New Window</Link>}
					</div>
				</div>
				<div style={{ padding: "0.3rem", textAlign: "center" }}>
					{reportLoading && <img src={reportLoader} alt="Loading " />}
					{hasError && <div>Error loading Compensation Report</div>}
					{noData && <div>No data is available for the selected period</div>}
				</div>
				<div className="row" style={(reportLoading || hasError || noData) ? { visibility: "hidden" } : { padding: "0.3rem" }}>
					<SpreadSheets workbookInitialized={setSpread} activeSheetChanged={spreadActiveSheetChanged} hostStyle={hostStyle}
						hostClass="col-md-12 col-lg-12 vh-100">
					</SpreadSheets>
				</div>
			</div>
		</div>
	);
};